// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__Im9Bx","chipDesktop":"styles_chipDesktop__6YfuT","chipMobile":"styles_chipMobile__PlKi5"};